import { API } from './class';

export const Api = new API();
